export const sanitizePhoneNumber = (value: string): string => {
  const digitsOnly = value.replace(/\D/g, '');
  return digitsOnly.replace(/^0+/, '').slice(0, 12);
};
